module.exports = __webpack_public_path__ + "img/consent-based-bg-lower.7e95f823.png";